module.exports = __webpack_public_path__ + "img/lock.d33480f9.svg";